import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user.js'
import conversation from './modules/conversation.js'
// import group from './modules/group.js'
import friend from './modules/friend.js'
import blacklist from './modules/blacklist'
import video from './modules/video'
import custom from './modules/custom'
import company from './modules/company'
import person from './modules/person'
import common from './modules/common'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        current: Date.now(), // 当前时间
        intervalID: 0,
        message: undefined
    },
    getters: {
        hidden(state) {
            // eslint-disable-next-line no-unused-vars
            const temp = state.current
            if (typeof document.hasFocus !== 'function') {
                return document.hidden
            }
            return !document.hasFocus()
        }
    },
    mutations: {
        startComputeCurrent(state) {
            state.intervalID = setInterval(() => {
                state.current = Date.now()
            }, 500)
        },
        stopComputeCurrent(state) {
            clearInterval(state.intervalID)
            state.intervalID = 0
        },
    },
    modules: {
        user,
        conversation,
        // group,
        friend,
        blacklist,
        video,
        custom,
        company,
        person,
        common,
    }
})
